import {Grid, Typography} from "@material-ui/core";
import React from "react";
import globalTheme from "../../../../theme/globalTheme";
import {currencyFormatter} from "../../../../../state/utils/Common";
import {Link} from "react-router-dom";

export const RequestsRow = props => {
    const commonTheme = globalTheme._default();
    return (
        <Link
            to={'/manager/requests/' + props.data.requests[props.index].uuid}>
            <Grid container spacing={2} key={props.data.requests[props.index].uuid} style={{
                ...props.style,
                paddingLeft: 21,
                paddingTop: 6,
                paddingBottom: 13,
                paddingRight: 29,
                borderBottom: "1px #CFCFCF solid"
            }}>
                <Grid item xs={1}>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                    >
                        {props.data.requests[props.index].id}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                    >
                        {props.data.requests[props.index].status_name}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                    >
                        {props.data.requests[props.index].type_name}
                    </Typography>
                </Grid>
                <Grid item xs={3} zeroMinWidth={true}>
                    <Typography
                        noWrap={true}
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                    >
                        {props.data.requests[props.index].account?.name}
                    </Typography>
                </Grid>
                <Grid item xs={1} zeroMinWidth={true}>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                        noWrap={true}
                    >
                        {props.data.requests[props.index].ebis_log_id}
                    </Typography>
                </Grid>
                <Grid item xs={1} zeroMinWidth={true}>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                        noWrap={true}
                    >
                        {props.data.requests[props.index].ebis_client_name}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                    >

                        {props.data.requests[props.index]?.amount != null &&
                            currencyFormatter(props.data.requests[props.index]?.amount)
                        }
                    </Typography>
                </Grid>
                <Grid item xs={1} zeroMinWidth={true}>
                    <Typography
                        noWrap={true}
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                    >
                        {props.data.requests[props.index].application_user_name}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                    >
                        {props.data.requests[props.index].application_complete_at}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                        className={commonTheme.breakWrap}
                    >
                        {props.data.requests[props.index].reflect_at}
                    </Typography>
                </Grid>

            </Grid>
        </Link>
    )
}
